import React, { createContext, useContext, useState, ReactNode } from "react";
import { translations, Lang, TranslationKey } from "./publicTranslations";

interface LangCtx {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: TranslationKey) => any;
}

const Ctx = createContext<LangCtx>(null!);

export function PublicLangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(
    () => (localStorage.getItem("pubLang") as Lang) || "sr"
  );

  const setLang = (l: Lang) => {
    localStorage.setItem("pubLang", l);
    setLangState(l);
  };

  const t = (key: TranslationKey): any =>
    (translations[lang] as any)?.[key] ?? (translations.sr as any)[key] ?? String(key);

  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
}

export const usePublicLang = () => useContext(Ctx);
